<input
  #inputRef
  [(ngModel)]="value"
  style="width: 100%"
  lumDecimalLimit
  [allowNegative]="false"
  (keydown)="onKeyDown($event)"
/>
